<h1
  class="
    text-white
    xl:text-3xl
    md:text-2xl
    text-xl
    tracking-wider
    select-none
    uppercase
    whitespace-nowrap
  "
>
  {{ label }}
</h1>
